import { snakeCase, text, timestamp, integer } from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { raffleStatusEnum } from './_common.table'
import { benefitsTable } from './benefits.table'
import { usersTable } from './users.table'

export const rafflesTable = snakeCase.table('raffles', {
    id: id('rfl'),
    benefitId: text()
        .notNull()
        .unique()
        .references(() => benefitsTable.id, {
            onDelete: 'cascade',
            onUpdate: 'cascade',
        }),
    applicationOpenAt: timestamp({
        withTimezone: true,
    }).notNull(),
    applicationCloseAt: timestamp({
        withTimezone: true,
    }).notNull(),
    drawDate: timestamp({
        withTimezone: true,
    }),
    numberOfWinners: integer().notNull(),
    prizeDescription: text(),
    status: raffleStatusEnum().notNull().default('open'),
    drawnAt: timestamp({
        withTimezone: true,
    }),
    drawnByUserId: text().references(() => usersTable.id, {
        onDelete: 'set null',
        onUpdate: 'cascade',
    }),
    ...timestamps,
})
